module.exports = __webpack_public_path__ + "static/staticSectionImage3-b8606ec3bf155122c5a4446e3fc2f09b.png";